import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { capture } from '../../utils/analytics';
import { fireOpened, fireClosed } from './iosInstallModalLogic';
import './IOSInstallModal.css';

function ShareIcon() {
  return (
    <svg
      className="tm-ios-modal__share-icon"
      viewBox="0 0 24 24"
      width="22"
      height="22"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M12 3.4l-4.2 4.2 1.4 1.4 1.8-1.8V15h2V7.2l1.8 1.8 1.4-1.4L12 3.4zM5 12v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8h-2v8H7v-8H5z"
      />
    </svg>
  );
}

export default function IOSInstallModal({ open, onClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    fireOpened(capture);
  }, [open]);

  const handleClose = useCallback(() => {
    fireClosed(capture);
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  if (!open) return null;

  return (
    <div
      className="tm-ios-modal-backdrop"
      role="presentation"
      onClick={handleClose}
      data-testid="ios-install-modal-backdrop"
    >
      <div
        className="tm-ios-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tm-ios-modal-title"
        onClick={(e) => e.stopPropagation()}
        data-testid="ios-install-modal"
      >
        <div className="tm-ios-modal__handle" aria-hidden="true" />
        <h2 id="tm-ios-modal-title" className="tm-ios-modal__title">
          {t('pwa.iosModal.title', 'Add TraderMap to Home Screen')}
        </h2>
        <ol className="tm-ios-modal__steps">
          <li className="tm-ios-modal__step">
            <span className="tm-ios-modal__step-num">1</span>
            <span className="tm-ios-modal__step-text">
              {t('pwa.iosModal.step1', 'Tap the Share button below')}
            </span>
            <ShareIcon />
          </li>
          <li className="tm-ios-modal__step">
            <span className="tm-ios-modal__step-num">2</span>
            <span className="tm-ios-modal__step-text">
              {t('pwa.iosModal.step2', 'Select "Add to Home Screen"')}
            </span>
          </li>
        </ol>
        <button
          type="button"
          className="tm-ios-modal__close"
          onClick={handleClose}
          data-testid="ios-install-modal-close"
        >
          {t('pwa.iosModal.close', 'Got it')}
        </button>
      </div>
    </div>
  );
}
